/* eslint-disable max-len */
export const landing = {
  'answer-on-questions': 'Պատասխանեք հարցերին',
  'candidate-page-title': 'Թեկնածուի հարցաթերթիկ',
  'choose-vacancy': 'Ընտրեք թափուր հաստիքը',
  'data-processing-and-agreement-links': 'Տալիս եմ իմ համաձայնությունը աշխատանքի հնարավոր տեղավորման նպատակով <a href="/pd_processing_policy_am.pdf" class="text-primary-100" target="_blank">իմ անձնական տվյալների մշակմանը</a> և ընդունում եմ <a href="/user_agreement_sm_podbor_am.pdf" class="text-primary-100" target="_blank">Օգտագործողի համաձայնագիրը</a>',
  'do-you-lead-a-healthy-lifestyle': 'Վարո՞ւմ եք առողջ ապրելակերպ',
  'do-you-play-sport': 'Զբաղվո՞ւմ եք սպորտով',
  'type-full-name': 'Մուտքագրեք անուն, ազգանուն, հայրանունը',
  'type-first-name': 'Մուտքագրեք անունը',
  'type-last-name': 'Մուտքագրեք ազգանունը',
  'type-patronymic-name': 'Մուտքագրեք միջին անունը',
  'full-name': 'Ա․Ա․Հ․',
  'error:birthday': 'Ընտրեք ծննդյան ամսաթիվը',
  'error:citizenship': 'Ընտրեք քաղաքացիությունը',
  'error:city': 'Ընտրեք քաղաքը',
  'error:email': 'Մուտքագրեք էլ․ հասցեն',
  'error:correct-email': 'Մուտքագրեք էլ․ հասցեն',
  'error:type-full-name': 'Մուտքագրեք ԱԱՀ-ն՝ անունը, ազգանունը և հայրանունը, միմյանցից անջատելով բացատներով',
  'error:type-first-name': 'Մուտքագրեք անունը',
  'error:type-last-name': 'Մուտքագրեք ազգանունը',
  'error:type-patronymic-name': 'Մուտքագրեք միջին անունը',
  'error:expected-income-level': 'Մուտքագրեք եկամուտի ակնկալվող մակարդակը',
  'error:phone': 'Մուտքագրեք հեռախոսահամարը',
  'error:phone-number': 'Մուտքագրեք հեռախոսահամարը',
  'error:prefered-communication-method': 'Ընտրեք կապի նախընտրելի միջոցը',
  'error:prefered-schedule': 'Ընտրեք ժամանակացույցը',
  'error:store': 'Ընտրեք խանութը',
  'error:recommender-city': 'Մուտքագրեք քաղաքը',
  'expected-income-level': 'Եկամուտի ակնկալվող մակարդակը, դրամ',
  'fill-personal-data': 'Լրացրեք անձնական տվյալները',
  'fill-required-fields': 'Լրացրե՛ք պարտադիր դաշտերը։',
  'for-example-basketball': 'Օրինակ՝ բասկետբոլ',
  'generating-telegram-link-please-wait': 'Կատարվում է Telegram բոտի հղման ձևավորում․ մի լքեք էջը, գործընթացը կարող է տևել մի քանի վայրկյան։',
  'go-to-telegram': 'Անցնել Telegram',
  'if-you-have-trouble-to-fill-form': 'Եթե դժվարանում եք լրացնել հարցաթերթիկը, զանգեք 8 800 350 80 60 հեռախոսահամարով',
  'if-you-have-trouble-to-fill-form-email': `Եթե հայտաձևի լրացման հետ կապված հարցեր ունեք, գրեք
    <a href="mailto:Support_smpodbor@sportmaster.com">Support_smpodbor@sportmaster.com</a> հասցեին`,
  'full-name-exemplicant': 'Հովհաննես Հովհաննեսի Հովհաննիսյան',
  'first-name-exemplicant': 'Հովհաննեսի',
  'last-name-exemplicant': 'Հովհաննես',
  'patronymic-name-exemplicant': 'Հովհաննիսյան',
  'link-our-telegram-for-more-info': 'Այցելեք մեր <a :href="telegramLink" class="text-primary-100" target="_blank">Telegram</a> ալիքը՝ հարցազրույցի հետագա փուլերի մասին տեղեկատվությունն ավելի արագ ստանալու համար',
  'online-stage-personal-link-email': 'Փոստին կուղարկվի անհատական հղում՝ առցանց փուլն անցնելու համար։',
  'online-stage-video-recording-agreement': 'Տալիս եմ իմ համաձայնությունը առցանց փուլի տեսաձայնագրման համար։',
  'phone-number': 'Հեռախոսահամար',
  'prefered-communication-method': 'Կապի նախընտրելի միջոց',
  'prefered-schedule': 'Ցանկալի ժամանակացույց',
  'previous-step': 'Նախորդ քայլը',
  'profile-vk': 'VK օգտահաշիվ',
  'questionnaire-sent-successfully': 'Հարցաթերթիկը հաջողությամբ ուղարկվել է',
  'online-stage-personal-link-sent-on-your-email': 'Ձեր <strong>{userEmail}</strong> էլ․ հասցեին ուղարկվել է անհատական հղում՝ առցանց փուլն անցնելու համար',
  'sales-representative': 'Առևտրային ներկայացուցիչ',
  'system-administrator': 'Համակարգի ադմինիստրատոր',
  'type-birthday': 'Մուտքագրեք ծննդյան ամսաթիվը',
  'type-profile-vk-link': 'Մուտքագրեք VK օգտահաշվի հղումը',
  'write-what-sport-do-you-do': 'Օրինակ՝ բասկետբոլ',
  'fill-questionnaire': 'Լրացրեք հարցաթերթիկի տվյալները',
  birthday: 'Ծննդյան ամսաթիվ',
  citizenship: 'Քաղաքացիություն',
  city: 'Քաղաք',
  loader: 'Բեռնակիր',
  next: 'Շարունակել',
  partner: 'Գործընկեր',
  phone: 'Հեռախոս',
  email: 'Էլ․ փոստ',
  step: 'Քայլ',
  store: 'Խանութ',
  ITN: 'ՀՎՀՀ',
  MSRN: 'Պետական գրանցման/հաշվառման/ համար',
  code: 'կոդ',
  'send-questionnaire': 'Ուղարկել հարցաթերթիկը',
  'recommender-data-title': 'Երաշխավորող անձի տվյալները',
  'has-work-in-this-company-before': 'Նախկինում աշխատել է Սպորտմաստեր ընկերությունում',
};
